// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".con-vs-dialog.con-vs-dialog-custom .vs-dialog header .con-title-after {\n  display: flex;\n  justify-content: space-between;\n}\n.con-vs-dialog.con-vs-dialog-custom .vs-dialog header .con-title-after .con-vs-tabs.vs-tabs {\n  width: initial;\n  align-self: center;\n}\n.con-vs-dialog.con-vs-dialog-custom .vs-dialog header .con-title-after .con-vs-tabs.vs-tabs ul.ul-tabs.vs-tabs--ul {\n  box-shadow: unset;\n}", ""]);
// Exports
module.exports = exports;
